export const configurationIssue = (configName) => {return {message:'Configuration not found. ' + configName };};
export const apiUrlError = {message:'API Url was not successfully build'};
export const apiUrlParamError = {message:'API Url parameter is not correct'};
export const missingParameterError = {message:'Missing required parameter'};
export const storeDataWasNowAvailable = {message:'Data sourced from Store was not available.'};